<template>
  <div>
    <b-row>
      <b-col>
        <label class="form-control-label">Phone Number</label><br />
        {{ textToPay.toPhone }}
      </b-col>
      <b-col>
        <label class="form-control-label">Amount</label><br />
        {{ (textToPay.amount / 100) | currency }}
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col>
        <label class="form-control-label">Sent</label><br />
        {{ textToPay.created | moment("MM/DD/YYYY") }}<br />
        <small class="text-muted">
          {{ textToPay.created | moment("hh:mm A") }}
        </small>
      </b-col>
      <b-col>
        <label class="form-control-label">Resent</label><br />
        {{ textToPay.resent | moment("MM/DD/YYYY") }}<br />
        <small class="text-muted">
          {{ textToPay.resent | moment("hh:mm A") }}
        </small>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col>
        <label class="form-control-label">Message</label><br />
        {{ textToPay.message }}
      </b-col>
    </b-row>
    <br />

    <br />
    <br />
    <b-button
      type="button"
      variant="primary"
      @click="reSendText"
      class="btn-block"
      >Resend</b-button
    >
    <br />
    <a href="#" @click.prevent="sendNewText">Send a new text message</a>
  </div>
</template>

<script>
export default {
  name: "text-to-pay-notification",
  props: { customer: null },
  data() {
    return {
      textToPay: {
        toPhone: null,
        fromPhone: null,
        amount: null,
        message: null,
      },
    };
  },
  methods: {
    async reSendText() {
      var self = this;
      var r = self.$client.post("/api/notification/reSendText", {
        Key: self.customer.key,
      });
    },
    sendNewText() {
      var self = this;
      self.$emit("sendNewText");
    },
  },
  async mounted() {
    var self = this;

    var r = await self.$client.get(
      "/api/notification/getTextToPay?customerKey=" + self.customer.key
    );

    if (r.data.isSuccess) {
      self.textToPay = r.data.value;
    }
  },
};
</script>

<style>
</style>